import React, { FC, memo, useCallback } from 'react';
import { useAppTranslation } from 'app/config/i18Config/hooks';
import { TableFilter, useTableFilterContext } from 'features/TableFilter';
import { BoxesListFilterKeys } from '../../model/types';
import { useAppSelector } from 'app/config/storeConfig/hooks';
import { getZoneBasics } from '../../model/selectors';
import { FloorSelect } from './FloorSelect';

export const BoxesListFilter: FC = memo(() => {
  const { t } = useAppTranslation('boxes');
  const { filters, changeFilters, clearCurrentFilters } = useTableFilterContext<BoxesListFilterKeys>();
  const basics = useAppSelector(getZoneBasics);

  const changeFloor = useCallback(
    (value: string, label: string) => {
      changeFilters({ key: BoxesListFilterKeys.floorId, label, value, title: t('Floor') });
    },
    [changeFilters, t],
  );

  return (
    <TableFilter withQueryStringFilters={false}>
      <div className="space-y-2">
        <FloorSelect
          selectedWarehouseId={basics?.warehouse?.warehouseId}
          value={filters.floorId?.value}
          onChange={changeFloor}
          onClear={clearCurrentFilters}
        />
      </div>
    </TableFilter>
  );
});
